import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 3H5v18l7-3 7 3V3z"
}), 'BookmarkSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BookmarkSharp.js
// module id = 2401
// module chunks = 2